// Why Confirm Payment is disabled, most basic reason first: no invoices beats
// a method that is still loading or failed to load.
export function paymentsMakePaymentsConfirmDisabledMessage(state: {
  invoicesSelected: number;
  loading: boolean;
  paymentMethodsLoadFailed: boolean;
}): string {
  if (state.invoicesSelected <= 0) {
    return "Select at least one invoice to pay";
  }
  if (state.loading) {
    return "Payment methods are still loading";
  }
  if (state.paymentMethodsLoadFailed) {
    return "We couldn't load your payment methods";
  }
  return "Select a payment method";
}
